import { createFileRoute } from "@tanstack/react-router";

import { OrderPage } from "../../../features/orders/order-page";

export const Route = createFileRoute("/_app/orders/$id")({ component: OrderRoute });

function OrderRoute() {
  const { id } = Route.useParams();
  return <OrderPage key={id} id={id} />;
}
